import {
  components,
} from '@/generated/qmulus/openapi.ts';

const maintenanceRecurrencePeriod: Record<NonNullable<components['schemas']['MaintenanceSeriesCreate']['recurrence']['period']>, string> = {
  never: 'Never',
  week: 'Weeks',
  month: 'Months',
  year: 'Years',
};

export default {
  title: 'Recurrence',
  repeat: 'Repeat',
  every: 'Every',
  on: 'On',
  end: 'End',
  maintenanceRecurrencePeriod,
  selectMonths: 'Select months',
};
